<template>
    <div>
        <div class="answer_sheet">
            <div class="answer_top">
                <div class="homework_difficult flex Flexalign">
                    <div class="line_green"></div>
                    <div class="difficult_text ml-20">最终成绩</div>
                </div>
                <div v-if="homeworkInfo.markScoreType == 1">
                    <div class="flex FlexBaseline testExam_score Flexjustify">
                        <div class="testExam_score_value">{{ homeworkInfo.questionScore }}</div>
                        <div>分</div>
                    </div>
                    <div class="flex FlexBaseline Flexjustify">
                        <el-image class="homework_score_icon" :src="iconPath('homework_score_icon.png')"></el-image>
                    </div>
                </div>
                <div v-if="homeworkInfo.markScoreType == 2">
                    <div class="level_gauge" v-if="this.homeworkInfo.markScoreShow == 2">
                        <customLevelGauge ref="customLevelGauge"></customLevelGauge>
                    </div>
                    <div class="level_gauge" v-if="this.homeworkInfo.markScoreShow == 3">
                        <customLevelGauge ref="customLevelGauge"></customLevelGauge>
                    </div>
                    <div class="level_gauge" v-if="this.homeworkInfo.markScoreShow == 1">
                        <customScorePie ref="customScorePie"></customScorePie>
                    </div>
                </div>

                <div class="marker_info px-15 py-20" v-if="homeworkInfo.markerComment">
                    <div class="flex Flexalign FlexWrap">
                        <el-image class="comments_icon mr-10" :src="iconPath('comments_icon.png')"></el-image>
                        <!-- <priviewImg :richText="$Tools.handlerImg(homeworkInfo.markerComment)"></priviewImg> -->
                        <div class="reviewer_comment">{{ homeworkInfo.markerComment }}</div>
                    </div>
                </div>
                <div class="marker_reviewer flex Flexalign mt-10">
                    <div class="reviewer_label">批阅人：</div>
                    <div class="reviewer_value">{{ homeworkInfo.markerName }}</div>
                </div>
                <div class="marker_reviewer flex Flexalign mt-10">
                    <div class="reviewer_label">批阅时间：</div>
                    <div class="reviewer_value">{{ homeworkInfo.markTime }}</div>
                </div>
            </div>
        </div>
        <div class="my-20" v-if="homeworkInfo.markScoreType == 2">
            <customHomeworLevelList ref="customHomeworLevelList"></customHomeworLevelList>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import customLevelGauge from "../echarts/customLevelGauge.vue";
import customScorePie from "../echarts/customScorePie.vue";
import customHomeworLevelList from "@/views/onlineLearning/components/customHomeworLevelList.vue";
// import priviewImg from "../richText/priviewImg.vue";
export default {
    name: "GjkcH5AnswerSheet",
    components: {
        customLevelGauge,
        customScorePie,
        customHomeworLevelList
    },
    computed: {
        ...mapState({

        }),
    },
    // components: { priviewImg },
    unmounted() {

    },

    data() {
        return {
            homeworkInfo: {}
        };
    },

    mounted() {

    },

    methods: {
        handlerHomeworkInfo() {
            let gradeList = ['D', 'C', 'B', 'A', 'A+'];
            let colorList = [];
            // markScoreShow 是否显示得分 1:得分 2:等级 3得分+等级
            if (this.homeworkInfo.markScoreShow == 2) {
                let gradeIndex = gradeList.findIndex(item => item == this.homeworkInfo.questionGrade);

                if (gradeIndex !== -1) {
                    // 创建颜色数组：前 gradeIndex+1 个为绿色，后面为灰色，最后一个是透明
                    colorList = [
                        ...Array(gradeIndex + 1).fill('#13D6AA'), // 绿色部分
                        ...Array(5 - (gradeIndex + 1)).fill('#F7F8FA'), // 灰色部分
                        "rgba(0,0,0,0)" // 透明
                    ];
                } else {
                    // 如果没找到等级，使用默认灰色
                    colorList = ['#F7F8FA', '#F7F8FA', '#F7F8FA', '#F7F8FA', '#F7F8FA', "rgba(0,0,0,0)"];
                }
                this.$refs.customLevelGauge.initCharts(colorList, this.homeworkInfo.questionGrade, 'level')
            } else if (this.homeworkInfo.markScoreShow == 3) {
                let gradeIndex = gradeList.findIndex(item => item == this.homeworkInfo.questionGrade);

                if (gradeIndex !== -1) {
                    // 创建颜色数组：前 gradeIndex+1 个为绿色，后面为灰色，最后一个是透明
                    colorList = [
                        ...Array(gradeIndex + 1).fill('#13D6AA'), // 绿色部分
                        ...Array(5 - (gradeIndex + 1)).fill('#F7F8FA'), // 灰色部分
                        "rgba(0,0,0,0)" // 透明
                    ];
                } else {
                    // 如果没找到等级，使用默认灰色
                    colorList = ['#F7F8FA', '#F7F8FA', '#F7F8FA', '#F7F8FA', '#F7F8FA', "rgba(0,0,0,0)"];
                }
                this.$refs.customLevelGauge.initCharts(colorList, this.homeworkInfo.questionScore, 'score')
            } else if (this.homeworkInfo.markScoreShow == 1) {
                let mockData = {
                    value: this.homeworkInfo.questionScore,
                    name: '得分评定'
                }
                this.$refs.customScorePie.initCharts(mockData);
            }

            // 各级凭项处理
            let levelList = [];
            this.homeworkInfo.markScoreDimensionality.forEach(item=>{
                let gradeList = [];
                for(let key in item.grades){
                    gradeList.push({label:item.grades[key],value:key})
                }
                levelList.push({name:item.name,gradeList,value:item.selectGrade});
            });
            this.$refs.customHomeworLevelList.levelList = levelList;
        },
    },
};
</script>

<style lang="scss" scoped>
.answer_sheet {
    width: 330px;
    // height: 847px;
    background: #ffffff;
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;

    .answer_top {
        padding-bottom: 10px;

        // border-bottom: 1px dashed #dedede;
        .homework_difficult {
            .line_green {
                width: 3px;
                height: 16px;
                background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
                border-radius: 4px;
            }

            .difficult_text {
                font-size: 18px;
                font-weight: 500;
                color: #111111;
            }
        }

        .level_gauge {
            height: 200px;
        }

        .answer_title {
            font-weight: bold;
            font-size: 20px;
            color: #333333;
            text-align: center;
        }

        .testExam_score {
            font-size: 14px;
            color: #FD673B;

            .testExam_score_value {
                font-weight: 500;
                font-size: 32px;
                color: #FD673B;
            }
        }

        .homework_score_icon {
            width: 49px;
            height: 21px;
        }

        .marker_info {
            background: #F6FAFF;
            border-radius: 10px;
            font-size: 14px;
            color: #111111;

            .comments_icon {
                width: 62px;
                height: 27px;
            }
        }

        .reviewer_comment {
            max-width: 100%;
            word-wrap: break-word;
        }

        .marker_reviewer {
            .reviewer_label {
                width: 90px;
                font-size: 16px;
                color: #999999;
            }

        }
    }
}

.marker_info {
    .markerComment {
        border: 1px solid #666;
        border-radius: 10px;
    }
}
</style>